module.exports = __webpack_public_path__ + "img/jcdecaux.6732dd3c.png";